<template>
  <div>
    <div class="row">
      <div class="col-md-2 text-left">
        <h3>Estoque</h3>
      </div>
      <div class="col-md-10 legenda text-right">
        <strong class="text-primary"> Ítens: </strong>{{ qtdItens }}
        <strong class="text-primary">| Produtos: </strong> {{ qtdProdutos }}
        <strong class="text-primary"> | Total: </strong> R$ {{ valorTotal }}
      </div>
    </div>
    <b-card>
      <b-row align-v="end">
        <b-col>
          <label for="">Produto</label>
          <b-form-input placeholder="Código" v-model="codigo" @keyup="searchProduto"
            @keyup.enter="changeFocusToQuantidade" v-mask="['##########']"></b-form-input>
        </b-col>
        <b-col>
          <label for="quantidade-produtos">Quantidade:</label>
          <input id="quantidade-produtos" type="text" v-mask="'######'" class="form-control" v-model="quantidade"
            @focus="blurQuantidade" @keydown.enter="saveEstoque(false)" />
        </b-col>
        <b-col>
          <b-button variant="success" @click="saveEstoque(false)"><i class="fa fa-plus-circle"></i>
            Adicionar</b-button>
        </b-col>
      </b-row>
      <b-row style="height: 30px;">
        <b-col>
          <small>
            {{ labelProduto.length > 0 ? labelProduto : "" }}
          </small>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-md-4">
          <b-input-group>
            <b-form-input id="filter-input" v-model="filter" type="search"
              placeholder="Buscar item no estoque"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col class="text-right">
          <b-button @click="exportar()" variant="success" size="sm"><i class="fas fa-file-excel"></i> Exportar Estoque</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table :items="dataComputed" :fields="colunas" :current-page="currentPage" :per-page="perPage"
            :filter="filter" class="mt-3" :filter-included-fields="filterOn" show-empty small hover responsive
            @filtered="onFiltered">
            <template #cell(botao)="row">
              <b-button variant="primary" title="Editar" @click="edit(row.item.codigo)"><i
                  class="fa fa-edit"></i></b-button>
              <b-button variant="danger" title="Deletar " class="mr-2" @click="deleteItemEstoque(row.item.codigo)"><i
                  class="fas fa-trash"></i></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" class="my-0" />
      <div class="row p-3">
        <div class="col-md-12 mt-2 text-right">
          <b-button variant="danger" size="sm" @click="deleteEstoque"><i class="fas fa-eraser"></i> Limpar Estoque
          </b-button>
        </div>
      </div>
    </b-card>

    <!-- Modal Editar Estoque-->
    <b-modal v-model="modalEstoque" :title="labelProduto">
      <b-card>
        <div class="row">
          <div class="col-md-12">
            <strong>Estoque Atual: </strong> {{ estoque[codigo] }} unidades
          </div>
          <div class="form-group col-md-12">
            <label for="">Quantidade</label>
            <input type="text" v-mask="'######'" class="form-control" v-model="quantidade" @focus="searchProduto"
              @keydown.enter="addEstoque" />
          </div>
          <div class="col-md-12 text-center container-btn">
            <b-button variant="success" size="sm" @click="saveEstoque(false)"><i class="fa fa-plus-circle"></i>
              Adicionar</b-button>
            <b-button variant="warning" size="sm" @click="saveEstoque(true)"><i class="fa fa-minus-circle"></i>
              Remover</b-button>
          </div>
        </div>
      </b-card>
      <template #modal-footer>
        <b-button variant="danger" size="sm" @click="modalEstoque = false">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalEstoque: false,
      overflowEstoque: 999999,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      filter: null,
      filterOn: ["codigo", "nome"],
      colunas: [
        {
          key: "codigo",
          label: "Código",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "nome",
          label: "Produto",
          sortable: true,
        },
        {
          key: "preco",
          label: "Preço R$",
          sortable: true,
        },
        {
          key: "quantidade",
          label: "Qtd",
          sortable: true,
        },
        {
          key: "total",
          label: "Total R$",
          sortable: true,
        },
        {
          key: "botao",
          label: " ",
        },
      ],
      estoque: {},
      tableData: [],
      produtos: {},
      quantidade: "",
      codigo: "",
      labelProduto: "",
      currentProduto: 0,
      items: []
    };
  },
  methods: {
    exportar() {
      axios
        .get("/distribuidor/estoque/get-link/export")
        .then((response) => {
          window.open('/distribuidor/estoque/export/' + response.data.resource);
        }).catch((error) => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getProdutos() {
      $(".loading").show();
      const vm = this;
      axios
        .get("/distribuidor/produtos/list")
        .then((response) => {
          let produtos = response.data;
          produtos.forEach((produto) => {
            vm.produtos[produto.codigo] = {
              id: produto.id,
              nome: produto.nome,
            };
          });
          $(".loading").hide();
        })
        .catch((error) => {
          alert("Erro ao carregar Produtos");
          console.log(error);
          $(".loading").hide();
        });
    },
    loadEstoque() {
      const vm = this;
      $(".loading").show();
      axios
        .get("/distribuidor/estoque/listar")
        .then((response) => {
          let estoques = response.data.length > 0 ? response.data : [];
          let tableData = [];
          let estoqueLocal = {};
          vm.totalRows = response.data.length;
          estoques.forEach((estoque) => {
            let preco = estoque.preco;
            let total = preco * estoque.quantidade;
            let obj = {
              id: estoque.id,
              codigo: estoque.codigo,
              nome: estoque.nome,
              preco: parseFloat(preco).toFixed(2).replace(".", ","),
              quantidade: estoque.quantidade,
              total: total.toFixed(2).replace(".", ","),
            };
            estoqueLocal[estoque.codigo] = estoque.quantidade;
            tableData.push(obj);
          });
          vm.tableData = tableData;
          vm.estoque = estoqueLocal;
          $(".loading").hide();
        })
        .catch((error) => {
          alert("Erro ao carregar Estoque");
          console.log(error);
          $(".loading").hide();
        });
    },

    blurQuantidade() {
      if (typeof this.produtos[this.codigo] === "undefined") {
        $("#input-codigo-produto").focus();
      }
    },

    searchProduto() {
      if (this.codigo === 0 || this.codigo === "0" || this.codigo === "") {
        this.labelProduto = "";
      } else if (
        typeof this.produtos[this.codigo] === "undefined" &&
        this.codigo !== 0
      ) {
        this.labelProduto = "Produto não Existe";
        $("#input-codigo-produto").focus();
      } else {
        this.labelProduto = this.produtos[this.codigo].nome;
      }
    },

    saveEstoque(deletar) {
      if (
        typeof this.produtos[this.codigo] === "undefined" ||
        this.quantidade <= 0
      ) {
        alert("Não é possível adicionar estes dados ao Estoque.");
        return;
      }

      let errorDelete =
        (typeof this.estoque[this.codigo] === "undefined" && deletar) ||
        (this.estoque[this.codigo] < this.quantidade && deletar);

      if (errorDelete) {
        alert("Não há produtos no estoque para deletar!");
        return;
      }

      let sumtoStorage =
        parseInt(this.quantidade) + parseInt(this.estoque[this.codigo]);

      if (!deletar && sumtoStorage > this.overflowEstoque) {
        alert(
          "A quantidade no estoque não pode ser superior a " +
          this.overflowEstoque
        );
        return;
      }

      const data = {
        produto: this.produtos[this.codigo].id,
        quantidade: this.quantidade,
        deletar: deletar,
      };

      this.postEstoque(data);
    },
    postEstoque(data) {
      const vm = this;
      $(".loading").show();
      axios
        .post("/distribuidor/estoque", data)
        .then((response) => {
          vm.loadEstoque();
          vm.clearForm();
          vm.modalEstoque = false;
        })
        .catch((error) => {
          alert(error.response.data.errors.join(""));
          console.log(error);
        }).finally(() => {
          $(".loading").hide();
        });
    },
    deleteEstoque() {
      let confirmation = confirm("Deseja realmente limpar todo o estoque?");

      if (!confirmation) {
        return;
      }

      $(".loading").show();
      var vm = this;
      let data = {
        _method: "DELETE",
      };
      axios
        .post("/distribuidor/estoque", data)
        .then(function (response) {
          $(".loading").hide();
          vm.loadEstoque();
        })
        .catch(function (error) {
          alert("Erro ao limpar estoque");
          $(".loading").hide();
          console.log(error);
        });
    },
    deleteItemEstoque(id) {
      this.$swal
        .fire({
          title: "Realmente deseja deletar este item do estoque ?",
          text: "Esta ação não poderá ser revertida.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, deletar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            var vm = this;
            let data = {
              _method: "DELETE",
            };
            axios
              .post("/distribuidor/estoque/" + id, data)
              .then((response) => {
                $(".loading").hide();
                vm.loadEstoque();
              })
              .catch((error) => {
                alert("Erro ao limpar estoque");
                $(".loading").hide();
                console.log(error);
              });
          }
        });
    },
    edit(codigo) {
      const vm = this;
      this.codigo = codigo;
      this.quantidade = 0;
      this.searchProduto();
      vm.modalEstoque = true;
      //$('#modal').modal();
    },
    changeFocusToQuantidade() {
      if (typeof this.produtos[this.codigo] === "undefined") {
        $("#input-codigo-produto").focus();
      } else {
        $("#quantidade-produtos").focus();
      }
    },
    clearForm() {
      $("#input-codigo-produto").focus();
      this.quantidade = "";
      this.codigo = "";
      this.labelProduto = "";
    },
  },

  computed: {
    dataComputed() {
      return this.tableData;
    },
    qtdItens() {
      var total = 0;

      for (var codigo in this.estoque) {
        total += this.estoque[codigo];
      }
      return total;
    },
    qtdProdutos() {
      return Object.keys(this.estoque).length;
    },
    valorTotal() {
      var total = 0;

      this.tableData.forEach((item) => {
        total += parseFloat(item.total.replace(",", "."));
      });
      return total.toFixed(2).replace(".", ",");
    },
  },

  mounted() {
    this.getProdutos();
    this.loadEstoque();
    $("#input-codigo-produto").focus();
  },
};
</script>

<style scoped="">
.container-btn {
  padding-top: 1.8em;
}

.legenda {
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/estoque/Main.vue